import { Component, Input, TemplateRef } from '@angular/core';
/**
 *
 * @group Data Visualization
 * @component Infographic Box
 *
 * @export
 * @class LsqInfographicBoxComponent
 * @property {string} [title] The title of the card.
 * @property {string} [value] The value of the title.
 * @property {string} [icon] The infographic icon that is displayed on the left.
 * @property {string} [color] Background color of the icon.
 */
@Component({
    selector: 'lsq-infographic-box',
    template: `
        <div class="box" *ngIf="value">
            <div class="box-icon-wrapper" [ngClass]="'bg-' + color">
                <i class="box-icon" [ngClass]="icon"></i>
            </div>
            <div class="box-info">
                <div class="box-value" *ngIf="value">
                    <ng-container
                        *ngIf="!templateRef; then singleValue; else templateValue"
                    ></ng-container>
                    <ng-template #singleValue>{{ value }}</ng-template>
                    <ng-template #templateValue>
                        <ng-container
                            [ngTemplateOutlet]="templateRef"
                            [ngTemplateOutletContext]="{ $implicit: value }"
                        ></ng-container>
                    </ng-template>
                </div>
                <div class="box-title">{{ title }}</div>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-infographic-box.component.scss']
})
export class LsqInfographicBoxComponent {
    @Input() public color: string;
    @Input() public title: string;
    @Input() public value?: string;
    @Input() public templateRef?: TemplateRef<any>;
    @Input() public icon: string;
}
